import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import * as React from 'react';

export type CheckboxProps = ChakraCheckbox.RootProps & {
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  rootRef?: React.Ref<HTMLLabelElement>;
};

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ children, inputProps, rootRef, ...rest }, ref) => (
    <ChakraCheckbox.Root
      ref={rootRef}
      cursor="pointer"
      _disabled={{ cursor: 'not-allowed' }}
      {...rest}
    >
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control
        border="1px solid"
        borderColor="gray.400"
        background="white"
        boxSize={4.5}
        focusRingColor="blue.500"
        _hover={{ borderColor: 'gray.500' }}
        _checked={{
          borderColor: 'green.700',
          background: 'green.700',
          _hover: {
            borderColor: 'green.800',
            background: 'green.800',
          },
        }}
        _disabled={{
          borderColor: 'gray.300',
          opacity: 1,
        }}
      >
        <ChakraCheckbox.Indicator />
      </ChakraCheckbox.Control>
      {children != null && (
        <ChakraCheckbox.Label
          color="gray.800"
          fontWeight="normal"
          _hover={{ color: 'gray.900' }}
          _disabled={{ color: 'gray.400', opacity: 1 }}
        >
          {children}
        </ChakraCheckbox.Label>
      )}
    </ChakraCheckbox.Root>
  )
);

export default Checkbox;
